import { render, staticRenderFns } from "./businessCardTC.vue?vue&type=template&id=1ce7168a&scoped=true&"
import script from "./businessCardTC.vue?vue&type=script&lang=js&"
export * from "./businessCardTC.vue?vue&type=script&lang=js&"
import style0 from "./businessCardTC.vue?vue&type=style&index=0&id=1ce7168a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce7168a",
  null
  
)

export default component.exports